import { render, staticRenderFns } from "./TopbarUserMenu.vue?vue&type=template&id=150092b6&"
import script from "./TopbarUserMenu.vue?vue&type=script&lang=js&"
export * from "./TopbarUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports